import type { Ticket, TicketCheckoutData } from "@/types";

const DEFAULT_LANGUAGE = 'da';

type LocalizationKeys = keyof Ticket['localizations'][string];

export const getLocalizedTicketValue = (
  ticketItem: Ticket | TicketCheckoutData,
  language: string = DEFAULT_LANGUAGE,
  key: LocalizationKeys,
  characterLimit: number = 0
): string => { 
  let value = ticketItem.localizations?.[language]?.[key] || Object.values(ticketItem.localizations || {}).find(localization => localization[key])?.[key] || '';
  if( characterLimit > 0  && value.length > characterLimit ) {
    value = value.slice(0, characterLimit) + '...';
  }
  return value;
};